import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { get } from 'lodash';
import { PAGE_SUB_TYPES, PAGE_TYPES } from '@sparefoot/tracking-events';

import withSearchHandler from 'decorators/withSearchHandler';
import './pspPage.scss';
import { Page } from 'components/core/Page';
import { PSPLayout } from 'components/organisms/PSPLayout';
import { NewFourOhFourPage } from 'pages/NewFourOhFourPage';
import withPageViewTracking from '../../components/core/library/tracking-utils/tracking/withPageViewTracking';
import { getPSPContent } from 'pages/PSPPage/PSPContentMap';
import { getMetadata } from 'pages/PSPPage/utils/getMetadata';
import PSPMeta from 'pages/PSPPage/PSPMeta';
import { pageTypes } from 'config/pageTypes';
import {
	buildReviewSchema,
	buildSGPWebPageSchema,
	buildSGPWebsiteSchema,
	buildPageSchema,
	PSP_PAGE_BY_KEY,
	buildSGPMainSizeGuidePageSchema,
	buildSGPIndividualPagesGuideSchema,
} from 'pages/PSPPage/utils/buildSchema';

export const enhance = compose(
	withPageViewTracking((props) => {
		const keyword = get(props.match, 'params.keyword') || props.keyword;
		return PSP_PAGE_BY_KEY[keyword] || PAGE_TYPES.PSP;
	}),
	withSearchHandler
);

export function PSPPage(props) {
	const { handleSearch, location } = props;
	const keyword = get(props.match, 'params.keyword') || props.keyword;
	const pageContent = getPSPContent(keyword);

	if (!pageContent) {
		return <NewFourOhFourPage {...props} />;
	}

	const metadata = getMetadata(pageContent.type);
	const reviewSchema = buildReviewSchema(pageContent);

	const schema = buildSchema(
		props.keyword ?? keyword,
		pageContent,
		reviewSchema,
	);
	const pageSchema = schema.webPage;
	const siteSchema = schema.webSite;
	const mainPageGuideSchema = schema.mainPageGuide;
	const individualPageGuideSchema = schema.individualPageGuide;

	return (
		<Page
			className="psp-page"
			pageType={PAGE_SUB_TYPES.STORAGE_LANDING}
		>
			<PSPMeta
				metadata={metadata}
				keyword={keyword}
				contentType={pageContent.pageType}
			/>
			<PSPLayout
				handleSearch={handleSearch}
				content={pageContent}
				pageSchema={pageSchema}
				pageType={pageContent.type}
				keyword={keyword}
				contentType={pageContent.pageType}
				pathname={location.pathname}
				siteSchema={siteSchema}
				mainPageGuideSchema={mainPageGuideSchema}
				individualPageGuideSchema={individualPageGuideSchema}
			/>
		</Page>
	);
}

function buildSchema(keyword, pageContent, reviewSchema) {
	switch (pageContent.pageType) {
		case pageTypes.SGP:
			return {
				webPage: JSON.stringify(
					buildSGPWebPageSchema(keyword, pageContent),
				),
				webSite: JSON.stringify(buildSGPWebsiteSchema()),
				mainPageGuide: JSON.stringify(
					buildSGPMainSizeGuidePageSchema(),
				),
				individualPageGuide: JSON.stringify(
					buildSGPIndividualPagesGuideSchema(keyword, pageContent),
				),
			};
		case pageTypes.PSP:
			return {
				webPage: JSON.stringify(
					buildPageSchema(keyword, pageContent, reviewSchema)
				),
				webSite: '',
			};
		default:
			return {
				webPage: '',
				webSite: '',
			};
	}
}

PSPPage.propTypes = {
	handleSearch: PropTypes.func.isRequired,
	match: PropTypes.object,
	keyword: PropTypes.string,
	location: PropTypes.object,
};

export default enhance(PSPPage);
